/* Pearled Candle Sand buy box — v6
   Money strings are rendered by Liquid in the visitor's market and only swapped here.
   No price arithmetic and no currency symbols in this file. */
(function () {
  function init(root) {
    if (root.dataset.epbReady) return;
    root.dataset.epbReady = '1';

    var json = function (sel) {
      var el = root.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    };

    var variants = json('[data-epb-variants]') || [];
    var cfg = json('[data-epb-config]') || {};
    if (!variants.length) return;

    var sizeIdx = (cfg.sizeOption || 0) - 1;     // zero-based, -1 when no size option
    var colourIdx = (cfg.colourOption || 0) - 1; // zero-based, -1 when no colour option

    var els = {
      price: root.querySelector('[data-epb-price]'),
      was: root.querySelector('[data-epb-was]'),
      save: root.querySelector('[data-epb-save]'),
      total: root.querySelector('[data-epb-total]'),
      totalSub: root.querySelector('[data-epb-total-sub]'),
      add: root.querySelector('[data-epb-add]'),
      addText: root.querySelector('[data-epb-add-text]'),
      msg: root.querySelector('[data-epb-msg]'),
      note: root.querySelector('[data-epb-note]'),
      hero: root.querySelector('.epb__hero img'),
      hint: root.querySelector('[data-epb-hint]')
    };

    // current selection, seeded from whatever Liquid rendered as selected
    var chosen = [];
    root.querySelectorAll('[data-epb-group]').forEach(function (g) {
      var on = g.querySelector('.is-on');
      var i = parseInt(g.dataset.epbGroup, 10) - 1;
      chosen[i] = on ? on.dataset.epbVal : null;
    });

    var picked = new Map(); // extras: variantId -> price in cents

    function find() {
      return variants.find(function (v) {
        return chosen.every(function (val, i) {
          return val == null || v.options[i] === val;
        });
      });
    }

    /* Is there an in-stock variant with this option value, given the other
       selections? Used to strike through and disable sold-out choices. */
    function inStock(optIdx, val) {
      return variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optIdx] !== val) return false;
        return chosen.every(function (c, i) {
          return i === optIdx || c == null || v.options[i] === c;
        });
      });
    }

    /* Is this colour or scent in stock in ANY pairing within the chosen size?
       That is the test for striking it through: a click on it will switch the
       other option to a working pairing, so it is only truly out when nothing
       in this size carries it. */
    function inStockInSize(optIdx, val) {
      return variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optIdx] !== val) return false;
        return sizeIdx < 0 || v.options[sizeIdx] === chosen[sizeIdx];
      });
    }

    /* Does this option value exist in stock anywhere, ignoring other choices?
       A size with no stock at all stays struck through permanently. */
    function inStockAnywhere(optIdx, val) {
      return variants.some(function (v) {
        return v.available && v.options[optIdx] === val;
      });
    }

    /* After a change, the other options may no longer be in stock. Keep the
       option the customer just clicked and move the others to the nearest
       in-stock values, so they never land on a dead combination. */
    function repair(lockedIdx) {
      var v = find();
      if (v && v.available) return;
      /* Size is never changed automatically. It sets the price, and someone who
         picked a size — or arrived on one from an ad link — must not be moved
         off it without noticing. Only colour and scent give way. If nothing in
         the chosen size is in stock we leave the selection alone and the button
         reads Sold out, which is the honest outcome. */
      var candidate = variants.filter(function (x) {
        if (!x.available) return false;
        if (lockedIdx != null && x.options[lockedIdx] !== chosen[lockedIdx]) return false;
        if (sizeIdx > -1 && x.options[sizeIdx] !== chosen[sizeIdx]) return false;
        return true;
      })[0];
      if (!candidate) return;
      chosen = chosen.map(function (c, i) {
        return (i === lockedIdx || i === sizeIdx) ? c : candidate.options[i];
      });
    }

    function setMsg(text, kind) {
      if (!els.msg) return;
      els.msg.textContent = text || '';
      els.msg.className = 'epb__msg' + (kind ? ' is-' + kind : '');
    }

    function render() {
      var v = find();

      // mark unavailable combinations without hiding them
      root.querySelectorAll('[data-epb-group]').forEach(function (g) {
        var i = parseInt(g.dataset.epbGroup, 10) - 1;
        g.querySelectorAll('[data-epb-val]').forEach(function (b) {
          var val = b.dataset.epbVal;
          var isSize = i === sizeIdx;
          // a size is only struck out when nothing in it is in stock, so the
          // customer can always move between sizes; colour and scent are struck
          // out whenever they are sold out for the current selection
          var isColour = i === colourIdx;
          /* Hierarchy: size > colour > scent.
             Size   — struck and disabled only when the whole size is out.
             Colour — struck only when it has nothing in stock in this size; never
                      disabled, because choosing it moves the scent to fit.
             Scent  — judged against the chosen size AND colour: anything out in
                      that pairing is struck and disabled. */
          var ok = isSize ? inStockAnywhere(i, val) : isColour ? inStockInSize(i, val) : inStock(i, val);
          b.classList.toggle('is-on', chosen[i] === val);
          b.classList.toggle('is-unavailable', !ok);
          var lock = !ok && chosen[i] !== val && !isColour;
          if (lock) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled');
          b.title = ok ? '' : (isColour ? 'Sold out in this size' : 'Sold out in this colour and size');
        });
      });

      root.querySelectorAll('[data-epb-chosen]').forEach(function (s) {
        var i = parseInt(s.dataset.epbChosen, 10) - 1;
        if (chosen[i]) s.textContent = chosen[i];
      });

      hint(v);
      if (!v) {
        if (els.add) els.add.disabled = true;
        if (els.addText) els.addText.textContent = cfg.unavailable || 'Unavailable';
        return;
      }

      root.dataset.current = v.id;

      if (els.price) els.price.textContent = v.price;
      if (els.was) {
        els.was.hidden = !v.compare_at;
        if (v.compare_at) els.was.textContent = v.compare_at;
      }
      if (els.save) {
        els.save.hidden = !v.save;
        if (v.save) els.save.textContent = (cfg.savePrefix || 'Save') + ' ' + v.save;
      }

      if (v.image) {
        gal.variantSrc = v.image;
        var vt = root.querySelector('[data-epb-thumb-variant]');
        if (vt) vt.src = v.image.replace(/width=1200/, 'width=200');
        /* on a plain landing the hero stays on the featured image until the
           customer chooses something; a variant link shows that variant */
        if (gal.interacted) galShow(0);
      }

      if (els.note) {
        var noteBtn = root.querySelector('[data-epb-valnote].is-on');
        els.note.textContent = noteBtn ? noteBtn.getAttribute('data-epb-valnote') : '';
      }

      // highlight the bowl that matches the chosen size
      var size = sizeIdx > -1 ? String(chosen[sizeIdx] || '').toLowerCase() : '';
      root.querySelectorAll('[data-epb-extra]').forEach(function (b) {
        var rec = String(b.dataset.epbRec || '').trim().toLowerCase();
        // prefix match: a label set to "500g" still highlights on "500g / 18oz"
        var isRec = !!(size && rec && size.indexOf(rec) === 0);
        b.classList.toggle('is-rec', !!isRec);
      });

      if (els.add) els.add.disabled = !v.available;
      if (els.addText) {
        els.addText.textContent = v.available ? (cfg.addText || 'Add to bag') : (cfg.soldOut || 'Sold out');
      }

      total(v);
    }

    /* Colour is the deliberate choice, scent follows it. After a colour click, if
       the current scent is not in stock in that colour and size, move the scent to
       one that is. Never runs on a scent click, so colour is never changed for
       the customer. */
    function followColour() {
      var v = find();
      if (v && v.available) return;
      var cand = variants.filter(function (x) {
        if (!x.available) return false;
        return chosen.every(function (c, k) {
          if (k === sizeIdx || k === colourIdx) return c == null || x.options[k] === c;
          return true; // any other option may change
        });
      })[0];
      if (!cand) return;
      chosen = chosen.map(function (c, k) { return (k === sizeIdx || k === colourIdx) ? c : cand.options[k]; });
    }

    /* When the chosen pairing is out, say so and offer the one-option changes that
       are in stock. Nothing is switched for the customer; they press the button. */
    function hint(v) {
      if (!els.hint) return;
      if (v && v.available) { els.hint.hidden = true; els.hint.innerHTML = ''; return; }
      var names = cfg.optionNames || [];
      var alts = [];
      chosen.forEach(function (cur, i) {
        if (i === sizeIdx || cur == null) return;
        variants.forEach(function (x) {
          if (!x.available) return;
          var differsOnlyHere = chosen.every(function (c, k) { return k === i ? true : (c == null || x.options[k] === c); });
          if (differsOnlyHere && x.options[i] !== cur && !alts.some(function (a) { return a.i === i && a.val === x.options[i]; })) {
            alts.push({ i: i, val: x.options[i] });
          }
        });
      });
      var parts = [];
      chosen.forEach(function (c, i) { if (i !== sizeIdx && c != null) parts.push(c); });
      var lead = parts.length === 2
        ? parts[1] + ' ' + (cfg.hintOut || 'isn\u2019t available in') + ' ' + parts[0] + (chosen[sizeIdx] ? ' at ' + chosen[sizeIdx] : '') + '.'
        : (cfg.soldOut || 'Sold out') + '.';
      var html = '<div>' + lead + '</div>';
      if (alts.length) {
        html += '<div class="epb__hint-alts"><span style="align-self:center">' + (cfg.hintTry || 'Available in') + '</span>';
        alts.forEach(function (a) {
          html += '<button type="button" class="epb__hint-alt" data-hint-i="' + a.i + '" data-hint-val="' + a.val.replace(/"/g, '&quot;') + '">' + a.val + '</button>';
        });
        html += '</div>';
      }
      els.hint.innerHTML = html;
      els.hint.hidden = false;
      els.hint.querySelectorAll('[data-hint-i]').forEach(function (b) {
        b.addEventListener('click', function () {
          chosen[parseInt(b.dataset.hintI, 10)] = b.dataset.hintVal;
          setMsg('');
          render();
        });
      });
    }

    /* Money formatting learned from a price Liquid rendered for this market, so
       a bowl + sand total carries the right symbol, position and separators in
       every currency without hardcoding any of them. */
    var MF = (function () {
      var sample = String(cfg.moneySample || '');
      var cents = Number(cfg.moneySampleCents || 0);
      var m = sample.match(/[\d][\d.,'\u2019\u00a0 ]*/);
      if (!m) return null;
      var num = m[0].replace(/[\u00a0 ]+$/, '');   // trailing space belongs to the suffix
      var prefix = sample.slice(0, m.index), suffix = sample.slice(m.index + num.length);
      var decimals = 2, decSep = '.', thouSep = ',';
      var tail = num.match(/([.,])(\d{1,2})$/);
      if (tail && cents % 100 === Number(tail[2].padEnd(2, '0'))) { decSep = tail[1]; }
      else { decimals = 0; }
      thouSep = decSep === '.' ? ',' : '.';
      var t = num.replace(new RegExp('\\' + decSep + '\\d{1,2}$'), '').match(/[^\d]/);
      if (t) thouSep = t[0];
      return { prefix: prefix, suffix: suffix, decimals: decimals, decSep: decSep, thouSep: thouSep };
    })();
    function fmtMoney(cents) {
      if (!MF) return null;
      var neg = cents < 0; cents = Math.abs(Math.round(cents));
      var whole = Math.floor(cents / 100), frac = String(cents % 100).padStart(2, '0');
      var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, MF.thouSep);
      return (neg ? '-' : '') + MF.prefix + w + (MF.decimals ? MF.decSep + frac : '') + MF.suffix;
    }

    /* Total: cents are only used to decide which pre-formatted string to show.
       When a bowl is ticked we cannot safely format a sum here, so we show the
       sand price and say a bowl is included rather than inventing a currency string. */
    function total(v) {
      if (!els.total) return;
      if (!picked.size) {
        els.total.textContent = v.price;               // exactly as Liquid rendered it
      } else {
        var cents = Number(v.price_cents || 0);
        picked.forEach(function (p) { cents += Number(p) || 0; });
        els.total.textContent = fmtMoney(cents) || v.price;
      }
      if (els.totalSub) {
        els.totalSub.textContent = picked.size
          ? (cfg.subWith || 'Candle sand + bowl')
          : (cfg.subSingle || 'Candle sand only');
      }
    }

    // option clicks
    root.querySelectorAll('[data-epb-group] [data-epb-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        if (btn.hasAttribute('disabled')) return;
        gal.interacted = true;
        var i = parseInt(btn.dataset.epbOpt, 10) - 1;
        chosen[i] = btn.dataset.epbVal;
        /* size and colour both sit above scent in the hierarchy: after either
           changes, the scent may move to stay in stock; colour never does */
        if (i === colourIdx || i === sizeIdx) followColour();
        setMsg('');
        render();
        var v = find();
        if (v && window.history && history.replaceState) {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        }
      });
    });

    /* ---- gallery: slot 0 is the selected variant's image, the rest are the
       general images. Arrows and swipe move through them; picking a variant
       resets to slot 0 and updates that slot's picture. ---- */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.epb__thumb'));
    var gal = { idx: 0, variantSrc: cfg.variantImage || (els.hero ? els.hero.src : ''), interacted: !!cfg.landedOnVariant };
    function galSrc(i) {
      if (i === 0) return gal.variantSrc;
      var t = thumbs[i]; return t ? t.dataset.epbThumb : '';
    }
    function galShow(i) {
      if (!els.hero || !thumbs.length) return;
      var n = thumbs.length;
      gal.idx = ((i % n) + n) % n;
      var src = galSrc(gal.idx);
      if (src) { els.hero.src = src; els.hero.removeAttribute('srcset'); }
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === gal.idx); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { galShow(k); }); });
    var prev = root.querySelector('[data-epb-prev]'), next = root.querySelector('[data-epb-next]');
    if (prev) prev.addEventListener('click', function () { galShow(gal.idx - 1); });
    if (next) next.addEventListener('click', function () { galShow(gal.idx + 1); });
    if (els.hero) {
      var x0 = null;
      els.hero.parentNode.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      els.hero.parentNode.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) galShow(gal.idx + (dx < 0 ? 1 : -1));
      }, { passive: true });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') galShow(gal.idx - 1);
        if (e.key === 'ArrowRight') galShow(gal.idx + 1);
      });
    }

    // bowls
    root.querySelectorAll('[data-epb-extra]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var id = b.dataset.epbExtra;
        if (picked.has(id)) { picked.delete(id); } else { picked.set(id, b.dataset.epbPrice); }
        b.classList.toggle('is-picked', picked.has(id));
        b.setAttribute('aria-pressed', picked.has(id) ? 'true' : 'false');
        setMsg('');
        var v = find();
        if (v) total(v);
      });
    });

    // add to bag — one call, sand first so a failing bowl cannot block it
    if (els.add) {
      els.add.addEventListener('click', function () {
        var v = find();
        if (!v || !v.available) return;

        els.add.disabled = true;
        setMsg('');

        var items = [{ id: v.id, quantity: 1 }];
        picked.forEach(function (_p, id) { items.push({ id: Number(id), quantity: 1 }); });

        fetch(window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (res.ok) {
              done();
              return;
            }
            // a bowl went out of stock between page load and click: retry with sand alone
            if (items.length > 1) {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
              }).then(function (r2) {
                if (!r2.ok) throw new Error('failed');
                var name = '';
                var first = root.querySelector('[data-epb-extra].is-picked .epb__extra-t');
                if (first) name = first.textContent.trim();
                done();
                setMsg(name + ' ' + (cfg.extraFailText || 'could not be added.'), 'warn');
              });
            }
            throw new Error('failed');
          })
          .catch(function () {
            els.add.disabled = false;
            setMsg(cfg.errorText || 'Something went wrong. Please try again.', 'error');
          });

        function done() {
          if (els.addText) els.addText.textContent = cfg.addedText || 'Added to bag';
          els.add.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            els.add.disabled = false;
            els.add.classList.remove('is-added');
            if (els.addText) els.addText.textContent = cfg.addText || 'Add to bag';
          }, 1800);
        }
      });
    }

    followColour();
    render();
    if (!gal.interacted && thumbs.length > 1) galShow(1);
  }

  function boot() {
    document.querySelectorAll('.epb[data-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // theme editor re-renders
  document.addEventListener('shopify:section:load', boot);
})();
